import { IAssignment } from '@medely/types';
import { Box } from '@medely/ui-kit';
import React from 'react';
import { AssignmentCancel } from './components/AssignmentCancel';
import ContactFacility from '@mp/components/contactFacility/ContactFacility';

type AssignmentActionsProps = {
  assignment: IAssignment & {
    facility_number?: string;
  };
  smallIcon?: boolean;
};

export const AssignmentActions = ({ assignment, smallIcon = false }: AssignmentActionsProps) => {
  const canBeCancelled = assignment.status === 'booked';
  const bookedOrInProgress = ['booked', 'in_progress'].includes(assignment.status);

  return (
    <Box pb={2}>
      {bookedOrInProgress && (
        <Box mb={2}>
          <ContactFacility
            contactableId={assignment.id}
            type="assignment"
            phone={assignment.facility_number}
            smallIcon={smallIcon}
          />
        </Box>
      )}
      {canBeCancelled && <AssignmentCancel />}
    </Box>
  );
};
